"use client";

import { useTranslations } from "next-intl";
import { motion } from "framer-motion";
import { TextMarquee } from "@/components/ui/LogoMarquee";
import { GradientDivider } from "@/components/ui/GradientDivider";
import { fadeUp, viewportOnce } from "@/lib/motion";

const SYSTEMS = [
  "Layher Allround",
  "Layher SpeedyScaf",
  "PERI UP Flex",
  "PERI UP Easy",
  "AT-PAC Metric",
  "AT-PAC Imperial",
  "Haki Universal",
  "Scafom-Rux Ringscaff",
  "MJ Gerüst Combi",
  "MJ Gerüst Optima",
  "Plettac Perfect Contur",
  "Plettac SL70/SL100",
  "Solideq Ramscaff",
  "Solideq Aluscaff",
  "Plus8",
  "Super 9",
  "Alustar",
  "StepUp Octo"
];

export function CompatibleSystemsSection() {
  const t = useTranslations("Home");

  return (
    <motion.section
      className="py-12 px-6"
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      variants={fadeUp}
    >
      <div className="flex flex-col mx-auto max-w-7xl text-center gap-8 lg:gap-12">
        <GradientDivider />
        <div>
          <p className="text-xs text-text-muted uppercase tracking-widest font-body mb-8">
            {t("systemsLabel")}
          </p>
          <TextMarquee items={SYSTEMS} direction="right" pixelsPerSecond={30} />
        </div>
        <GradientDivider />
      </div>
    </motion.section>
  );
}
